export default "__VITE_ASSET__4fb975e4__"